<template>
  <div class="header clearfix">
    <el-dropdown class="right" trigger="click" style="cursor: pointer">
      <div class="head-img el-dropdown-link">
        <el-avatar style="margin-top: 0px; float: left; margin-right: 10px" :size="50">
          <img src="../../assets/img/head-img.png" />
        </el-avatar>
        <span style="padding-top: 15px; float: right">{{ userName }}</span>
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item>
          <router-link to="/Personal/Organization">机构信息</router-link>
        </el-dropdown-item>
        <el-dropdown-item>
          <router-link to="/Personal/ResetPwd">修改密码</router-link>
        </el-dropdown-item>
        <el-dropdown-item>
          <p @click="loginout">退出登录</p>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-badge :is-dot="true" class="messages right" v-if="showMsgDot" style="cursor: pointer">
      <i class="el-icon-bell" style="font-size: 24px" @click="showMsg"></i>
    </el-badge>
    <el-badge :is-dot="false" class="messages right" v-else style="cursor: pointer">
      <i class="el-icon-bell" style="font-size: 24px" @click="showMsg"></i>
    </el-badge>
    <div class="messages right" style="cursor: pointer">
      <i class="el-icon-question" @click="toPage" style="cursor: pointer">帮助中心</i>
    </div>
    <template v-if="ClientId == QYClient || ClientId == YunClient || ClientId == FairClient">
      <el-badge :is-dot="true" class="messages right" v-if="!showJw && notReadMessage > 0" style="cursor: pointer">
        <i class="el-icon-headset" style="font-size: 24px" @click="showDialog"></i>
      </el-badge>
      <el-badge :is-dot="false" class="messages right" v-else style="cursor: pointer">
        <i class="el-icon-headset" style="font-size: 24px" @click="showDialog"></i>
      </el-badge>
      <!-- https://chatv2-jwchat-c708817706894990ccfcbbc84e9d7e722741a4c12dcdad78f.gitlab.io/ -->
      <!-- 
      v-model	输入框中的文字	String	-	""
      taleList	会话内容	Array	-	[]
      toolConfig	工具栏配置	Object	-	{}
      width	JwChat界面框宽度	string	-	750px
      height	JwChat界面框高度	string	-	570px
      config	组件配置	Object	-	{}
      scrollType	消息自动到低	String	scroll	noroll
      showRightBox	显示右边内容	Boolean	false	true
      winBarConfig	多窗口配置
      quickList   自动匹配快捷回复
      @enter	输入框点击就发送或者回车触发的事件	输入的原始数据
      @clickTalk	点击聊天框列中的用户和昵称触发事件	当前对话数据
     -->

      <div class="jw-box" v-if="showJw" :style="{ 'padding-top': `20px` }">
        <i class="el-icon-close closeBtn" @click="showDialog"></i>
        <JwChat-index ref="jwChat" class="jw" :config="config" :showRightBox="ClientId == YunClient || ClientId == FairClient? true : false" scrollType="scroll" :taleList="messageList" @enter="bindEnter" v-model="inputMsg" :toolConfig="tool" width="90%" height="calc(100vh - 134px)" :winBarConfig="winBarConfig" @clickTalk="talkEvent" :quickList="config.quickList">
          <Rightbox ref="Rightbox" @sendCard="sendCard" @sendRecordCard="sendRecordCard" @stopConsultation="stopConsultation" @complateConsultation="complateConsultation" @sedFirstMsg="sedFirstMsg" v-show="this.currentUserInfo.id"></Rightbox>
          <!-- 自定义插槽 -->
          <template v-slot:tools>
            <el-upload ref="upload" :headers="headers" :action="CommonFilePath" :limit="1" class="avatar-uploader" :show-file-list="false" :on-success="handleSuccess" accept=".png,.jpg,.jpeg,.gif" :before-upload="beforeUpload">
              <i class="el-icon-picture-outline" style="font-size: 20px; margin-left: 5px; margin-top: 8px"></i>
            </el-upload>
            <el-upload ref="uploadVideo" :headers="headers" :limit="1" class="avatar-uploader" :show-file-list="false" action="" :before-upload="beforeUploadVideo" accept=".mp4">
              <i class="el-icon-video-camera" style="font-size: 20px; margin-left: 5px; margin-top: 8px"></i>
            </el-upload>
            <i class="el-icon-goods" style="font-size: 20px; margin-left: 5px" @click="showGoods()" v-if="ClientId == QYClient"></i>
          </template>
        </JwChat-index>
      </div>
      <el-badge value="hot" class="" style="margin: 0 30px; cursor: pointer" v-if="ClientId == QYClient">
        <div class="flex-space-around" style="background: var(--base--Color); color: #fff; border-radius: 5px; width: 150px; padding: 5px 0; cursor: pointer" @click="toSquare">
          <img style="width: 30px; height: 30px" src="../../assets/img/cj.png" />
          <div class="flex-center-column">
            <span style="line-height: 20px">选品广场</span>
            <span style="line-height: 20px">厂家直供</span>
          </div>
        </div>
      </el-badge>
    </template>
    <el-dialog class="" :visible.sync="dialogVisible" width="55%" :append-to-body="true" :z-index="99999">
      <el-table :data="goodsList" stripe style="width: 100%" height="440px">
        <el-table-column type="index" label="编号" width="80"></el-table-column>
        <el-table-column prop="name" label="商品" />
        <el-table-column prop="stockNum" label="库存" />
        <el-table-column prop="ordinaryPrice" label="价格(元)" align="center" />
        <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="sedGoods(scope.row)" plain :disabled="scope.row.stockNum == 0">发送商品</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="flex-center"><el-pagination @current-change="ChangePage" :page-size="PageSize3" :current-page="PageIndex3" :total="dataCount3" layout="total, prev, pager, next, jumper"></el-pagination></div>
    </el-dialog>

    <el-dialog title="终止问诊原因" :visible.sync="refuseDialog" width="450px" :append-to-body="true" :z-index="99999">
      <el-form class="dialog-form" :model="refuseForm" ref="refuseForm" :rules="rules" :label-width="formLabelWidth">
        <el-form-item prop="refusalReason">
          <el-input v-model="refuseForm.refusalReason" type="textarea" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="CloseBtn('refuseForm')">取 消</el-button>
        <el-button type="primary" @click="SaveBtn('refuseForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { User } from "../../components/HospitalDomain/User";
import { Msg } from "../../components/HospitalDomain/Msg";
import { Promise } from "../../utils/es6-promise.min";
import { Commodity } from "../../components/HospitalDomain/ShopMall/commodity";
import { Chathub } from "../../components/HospitalDomain/Chathub";
import { Videos } from "../../components/HospitalDomain/Videos/Videos";
import Rightbox from "./Rightbox.vue";
import { DoctorAppointment } from "../../components/DrugDomain/DoctorAppointment.js";
import "../../utils/aliyun-upload-sdk-1.5.3.min.js";
import "../../utils/es6-promise.min.js";
import OSS from "../../utils/aliyun-oss-sdk-6.17.1.min.js";
window.OSS = OSS;
var timeout = 10000; //超时时间
var loading = null;

export default {
  name: "headCenter",
  components: {
    Rightbox,
  },
  computed: {
    headers() {
      return {
        Authorization: "Bearer" + " " + JSON.parse(sessionStorage.getItem(this.ClientId + "Token")).access_token,
      };
    },
  },
  data() {
    var msg = new Msg(this.TokenClient, this.Services.Chathub);
    var user = new User(this.TokenClient, this.Services.Authorization);
    var commodity = new Commodity(this.TokenClient, this.Services.Shopping);
    var userChat = new Chathub(this.TokenClient, this.Services.Chathub);
    var videos = new Videos(this.TokenClient, this.Services.Healthy);
    var doctorAppointment = new DoctorAppointment(this.TokenClient, this.Services.Drug);
    return {
      DoctorAppointment: doctorAppointment,
      VideosDomain: videos,
      CommodityDomain: commodity,
      UserChat: userChat,
      MsgDomain: msg,
      UserDomain: user,
      userName: "",
      pageIndex: 1,
      showJw: false,
      loadMsg: true,
      inputMsg: "",
      messageList: [], //消息列表
      userList: [],
      tool: {
        show: [],
        showEmoji: false,
        callback: this.toolEvent,
      },
      userLogo: "https://api.qyyl365.com/authorization/PC/userlogo.png",
      shopLogo: "https://api.qyyl365.com/authorization/PC/shoplogo.png",
      config: {
        img: "",
        name: "机构名称",
        dept: "用户名称",
        callback: this.bindCover,
        historyConfig: {
          show: true,
          tip: "加载更多",
          callback: this.bindLoadHistory,
        },
        quickList: [{ text: "这里是jwchat，您想了解什么问题。" }, { text: "jwchat是最好的聊天组件" }],
      },
      winBarConfig: {
        active: "0",
        width: "14vw",
        listHeight: "60px",
        list: [], //z左侧列表
        callback: this.bindWinBar,
      },
      rightConfig: {
        listTip: "",
        notice: `<el-button @click="drawer = true" type="primary" style="margin-left: 16px"> 点我打开 </el-button>`,
        filterTip: "好友过滤",
        list: [
          {
            name: "JwChat",
            img: "https://api.qyyl365.com/authorization/PC/userlogo.png",
            id: 1,
          },
          {
            id: 2,
            name: "JwChat",
            img: "https://api.qyyl365.com/authorization/PC/userlogo.png",
          },
          {
            id: 3,
            name: "JwChat",
            img: "https://api.qyyl365.com/authorization/PC/userlogo.png",
          },
          {
            id: 4,
            name: "留恋人间不羡仙",
            img: "https://api.qyyl365.com/authorization/PC/userlogo.png",
          },
          {
            id: 5,
            name: "只盼流星不盼雨",
            img: "https://api.qyyl365.com/authorization/PC/userlogo.png",
          },
        ],
      },
      wsUrl: this.Services.ChathubHubs,
      token: JSON.parse(sessionStorage.getItem(this.ClientId + "Token")).access_token,
      orgInfo: JSON.parse(sessionStorage.getItem("userInfo")),
      currentUserInfo: {
        id: 0,
      },
      orderInfo: {},
      showMsgDot: false,
      sessionId: "",
      isLogin: false,
      uploaded: false,
      resVideo: "", //视频地址
      uploader: null,
      PageIndex1: 1,
      PageTotal1: 1,
      PageSize1: 100,
      dataCount: 0,
      dialogVisible: false,
      goodsList: [],
      PageIndex3: 1,
      PageTotal3: 1,
      PageSize3: 0,
      dataCount3: 0,
      notReadMessage: 0,
      chatMessageCount: 0,
      chatMessageNotify: null,
      rules: {
        refusalReason: [{ required: true, message: "请填写终止问诊原因", trigger: "blur" }],
      },
      refuseForm: {
        id: 0,
        refusalReason: "",
      },
      refuseDialog: false,
      formLabelWidth: "15px",
      orderInfo: {},
      detailInfo: {},
    };
  },
  destroyed() {
    // 消息通知
    window.removeEventListener("onmessageWS", this.getSocketData);
    window.removeEventListener("ReceiveToUserMsg", this.getChathubSocketData);
    if (this.chatMessageNotify) {
      this.chatMessageNotify.close();
    }
  },
  created() {
    this.initMsg();
    this.userName = this.UserDomain.GetSessionUserInfo().name;
    if (this.ClientId == this.QYClient || this.ClientId == this.YunClient || this.ClientId == this.AssociationClient || this.ClientId == this.FairClient) {
      this.messageList = [];
      this.currentUserInfo.id = 0;
      this.msgNum = 0;
      this.showJw = false;
      this.winBarConfig.list = [];
      this.initChathubMsg();
      this.getUserNotReadMessage();
      if (this.ClientId == this.YunClient || this.ClientId == this.AssociationClient || this.ClientId == this.FairClient) {
        this.shopLogo = "https://oss.qyyl365.com/PC/touxiang.png";
      }
    }
  },
  mounted() {
    window.toGoods = this.toGoods;
    window.toGoodsOrder = this.toGoodsOrder;
    // 在线问诊联系患者
    this.$bus.$off("showDialog");
    this.$bus.$on("showDialog", (item) => {
      console.log(item);
      this.orderInfo.groupId = item.groupId;
      this.showDialog();
    });
  },
  methods: {
    initChathubMsg() {
      window.addEventListener("ReceiveToUserMsg", this.getChathubSocketData);
      // 检测浏览器是否支持Websocket
      if (typeof WebSocket == "undefined") {
        this.$alert("系统检测到您的浏览器不支持Websocket通信协议，这将会导致您无法正常进行课堂互动！建议您更换浏览器进行观看！", "警告", {
          confirmButtonText: "知道了",
          callback: () => {},
        });
      }
    },
    getChathubSocketData(res) {
      if (res.type == "ReceiveToUserMsg") {
        let message = JSON.parse(res.detail.data);
        // 处理接收到的消息，此处仅打印到控制台
        console.log("接收到消息:", message, this.currentUserInfo.id);
        if (!this.showJw) {
          this.getUserNotReadMessage();
          this.setMessage("提示", "", {}, "您有新的聊天消息！", "去解决", "chat");
          return;
        }
        if (message.id) {
          // 不是当前会话的新消息,刷新会话列表；是，刷新并选中菜单
          if (message.groupId == this.currentUserInfo.id) {
            this.initUserGroup("isSetCurrentUserInfo");
          } else {
            this.initUserGroup();
          }
        }
      }
    },
    /**
     * 初始化客服聊天列表
     */
    initUserChat(connected) {
      console.log("客服聊天服务状态", connected.detail.data);
      this.getUserNotReadMessage();
      this.isLogin = true;
      if (connected.detail.data) {
        // 聊天框未打开不加载信息
        if (!this.showJw) {
          this.winBarConfig.list = [];
        } else {
          // 聊天框打开：发送消息断联重新加载当前聊天信息；刷新聊天用户列表并加载消息
          if (this.currentUserInfo.id) {
            this.initUserGroup();
          } else {
            this.initUserGroup("isSetCurrentUserInfo");
          }
        }
      }
    },
    /**
     * 获取用户对话分组列表
     */
    getUserGroup() {
      var _this = this;
      return new Promise((resolve, reject) => {
        _this.UserChat.AddToCustomerGroup(
          _this.orgInfo.id,
          _this.orgInfo.organizationId,
          _this.PageIndex1,
          _this.PageSize1,
          function (data) {
            _this.PageIndex1 = data.data.pageIndex;
            _this.PageSize1 = data.data.pageSize;
            _this.PageTotal1 = data.data.pageCount;
            _this.dataCount = data.data.dataTotal;
            resolve(data.data.results);
          },
          function (err) {
            console.log(err);
            var jsonObj = JSON.parse(err.msg);
            if (jsonObj.code == "400") {
              _this.$message({
                type: "error",
                message: jsonObj.msg,
              });
            }
            resolve([]);
          }
        );
      });
    },
    /**
     * 获取用户对话分组列表
     */
    getDiseaseUserGroup() {
      var _this = this;
      return new Promise((resolve, reject) => {
        _this.UserChat.AddToCustomerGroupDisease(
          _this.PageIndex1,
          _this.PageSize1,
          function (data) {
            _this.PageIndex1 = data.data.pageIndex;
            _this.PageSize1 = data.data.pageSize;
            _this.PageTotal1 = data.data.pageCount;
            _this.dataCount = data.data.dataTotal;
            resolve(data.data.results);
          },
          function (err) {
            console.log(err);
            var jsonObj = JSON.parse(err.msg);
            if (jsonObj.code == "400") {
              _this.$message({
                type: "error",
                message: jsonObj.msg,
              });
            }
            resolve([]);
          }
        );
      });
    },
    getUserNotReadMessage() {
      var _this = this;
      _this.UserChat.GetUserNotReadMessage(
        function (data) {
          _this.notReadMessage = data.data;
        },
        function (err) {
          console.log(err);
          var jsonObj = JSON.parse(err.msg);
          if (jsonObj.code == "400") {
            _this.$message({
              type: "error",
              message: jsonObj.msg,
            });
          }
          resolve([]);
        }
      );
    },
    /**
     * 处理聊天列表信息
     */
    async initUserGroup(isSetCurrentUserInfo) {
      let userList = [];
      if (this.ClientId == this.QYClient) {
        userList = await this.getUserGroup();
      }
      if (this.ClientId == this.YunClient || this.ClientId == this.FairClient) {
        userList = await this.getDiseaseUserGroup();
      }

      this.winBarConfig.list = [];
      this.currentUserInfo = {};
      this.config.name = this.currentUserInfo.name;
      this.config.dept = "";
      this.config.img = "";
      this.messageList = [];
      this.pageIndex = 1;
      if (userList.length > 0) {
        userList.forEach((item) => {
          let userLogo = item.bindUserInfo.photoFile ? `${this.CommonPath}${item.bindUserInfo.photoFile}` : this.userLogo;
          let lastMessage = item.lastMessage?.content ?? "";
          switch (item.lastMessage?.contentType) {
            case "image":
              lastMessage = "图片";
              break;
            case "video":
              lastMessage = "视频";
              break;
            case "goods":
              lastMessage = "商品";
              break;
            case "order":
              lastMessage = "订单";
              break;
            case "doctorDesc":
              lastMessage = "医生信息";
              break;
            case "caseCard":
              lastMessage = "病历卡";
              break;
          }
          let userInfo = {
            id: item.id,
            bindUserId: item.bindUserId, //用户ID bindUserId
            bindOrganizationUserId: item.bindOrganizationUserId,
            dept: lastMessage,
            img: userLogo, //头像
            Sex: item.bindUserInfo.sex, //性别
            groupName: item.groupName, //用户名
            name: item.bindUserInfo.userName, //会话名
            readNum: item.isNotReadMessage > 99 ? "99+" : item.isNotReadMessage,
          };
          this.winBarConfig.list.push(userInfo);
        });
        if (isSetCurrentUserInfo) {
          // 由订单点击的，选中问诊订单聊天
          if (this.orderInfo?.groupId) {
            this.currentUserInfo = this.winBarConfig.list.filter((i) => i.id == this.orderInfo?.groupId)[0];
          } else {
            // 直接点开聊天框的默认选中一个聊天
            this.currentUserInfo = this.winBarConfig.list[0];
          }
          this.winBarConfig.active = this.currentUserInfo.id;
          this.config.name = this.currentUserInfo.name;
          this.config.dept = "";
          this.config.img = "";
          if (this.ClientId == this.YunClient || this.ClientId == this.FairClient) {
            // 获取右侧信息
            let isFirst = this.currentUserInfo.groupName.split("_")[4];
            let res = await this.$refs.Rightbox.getDetail(this.currentUserInfo.groupName.split("_")[3], isFirst);
            if (res.photoFile) {
              this.shopLogo = `${this.CommonPath}${res.photoFile}`;
            }
          }

          // 选中聊天组信息设置已读
          if (this.currentUserInfo.readNum) {
            this.setMessageIsReader();
          }
          this.getMessagesBygroupId();
        }
      }
    },
    /**
     *  第一次聊天发送医生信息和病历卡
     */
    sedFirstMsg(item) {
      // 第一次聊天发送医生信息和病历卡
      var _this = this;
      let str = JSON.stringify(item.data);
      _this.UserChat.DiseaseServerStartChat(
        this.currentUserInfo.id,
        function (data) {
          _this.sendEnter(_this.currentUserInfo.id, "doctorDesc", str, _this.orgInfo.id, true);
          _this.sendEnter(_this.currentUserInfo.id, "caseCard", str, _this.orgInfo.id, true);
          _this.sendEnter(_this.currentUserInfo.id, "message", "请确认您的病例信息", _this.orgInfo.id, true);
        },
        function (err) {
          console.log(err);
          var jsonObj = JSON.parse(err.msg);
          if (jsonObj.code == "400") {
            _this.$message({
              type: "error",
              message: jsonObj.msg,
            });
          }
        }
      );
    },
    /**
     * 点击用户列表
     * @param {*} play
     */
    bindWinBar(play = {}) {
      const { type, data = {} } = play;
      if (type === "winBar") {
        this.orderInfo = {};
        this.getUserNotReadMessage();
        this.setData(data);
        return;
      }
      if (data.type === "remove") {
        this.$message({
          type: "warning",
          message: "暂未开通",
        });
        return;
      }
    },
    setData(data) {
      // console.log("点击用户列表", data);
      this.winBarConfig.active = data.id;
      this.config.name = data.name;
      // this.config.dept = data.groupName;
      // this.config.img = data.img ?? this.userLogo;
      this.messageList = [];
      this.pageIndex = 1;
      this.currentUserInfo = data;
      if (data.readNum) {
        this.setMessageIsReader();
      }

      this.getMessagesBygroupId();
    },
    setMessageIsReader() {
      var _this = this;
      _this.UserChat.MessageIsReader(
        this.currentUserInfo.id,
        this.currentUserInfo.bindOrganizationUserId,
        function (data) {
          const index = _this.winBarConfig.list.findIndex((i) => i.id === _this.currentUserInfo.id);
          _this.winBarConfig.list[index].readNum = "";
        },
        function (err) {
          console.log(err);
          var jsonObj = JSON.parse(err.msg);
          if (jsonObj.code == "400") {
            _this.$message({
              type: "error",
              message: jsonObj.msg,
            });
          }
        }
      );
    },
    /**
     * 加载接收消息
     * @param item
     */
    loadUserChatMsg(item) {
      var _this = this;
      var messageList = [];
      if (!this.messageList.some((i) => i.id == item.id)) {
        var text = this.getMsgStr(item.contentType, item.content);
        var message = {
          id: item.id, //会话编号
          groupId: item.groupId,
          FromUserId: item.fromUserId, //发送者
          To: item.toUser, //接收者，MsgType=USER时为用户ID，MsgType=GROUP时为群ID
          MsgType: item.msgType, //消息类型，同item.SessionType
          mine: item.fromUserId == this.currentUserInfo.bindUserId ? false : true,
          img: item.fromUserId == this.currentUserInfo.bindUserId ? this.userLogo : this.shopLogo,
          name: item.fromUserId == this.currentUserInfo.bindUserId ? "" : item.name,
          date: this.timefilters(item.sendTime), //发送时间
          text: text, //正文
          Timestamp: this.timeFormat(item.sendTime),
          ContentType: item.contentType, //正文类型
        };
        messageList.push(message);
      }
      if (_this.messageList.length == 0) {
        _this.messageList = messageList.concat(_this.messageList);
      } else if (_this.messageList[_this.messageList.length - 1].Timestamp < messageList[0].Timestamp) {
        _this.messageList = _this.messageList.concat(messageList);
      } else {
        _this.messageList = messageList.concat(_this.messageList);
      }
    },
    /**
     * 消息处理
     * @param contentType
     * @param content
     */
    getMsgStr(contentType, content) {
      var text = { text: `${content}` };
      if (contentType == "image") {
        text = { text: "<img data-src='" + `${this.CommonPath}${content}` + "'/>" };
      } else if (contentType == "video") {
        text = { text: `<video width="745" height="420" controls="controls" data-src=${content} />` };
      } else if (contentType == "goods") {
        var msgInfo = JSON.parse(content);
        sessionStorage.setItem("goodsName", msgInfo.name);
        let img = msgInfo.coverImageUrls.indexOf(",") > -1 ? msgInfo.coverImageUrls.split(",")[0] : msgInfo.coverImageUrls;
        let img1 = `${this.CommonPath}${img}`;
        text = {
          text: `<div style="width: 240px;height: auto;position: relative; color:#333;padding:10px 5px;cursor: pointer;" onclick="toGoods()"><div class="flex-start"><img object-fit='fill'style="width:60px;height:60px;margin-right:5px;object-fit: cover;border-radius: 10px;" src="${img1}"/><div style='display: flex;flex-direction: column;justify-content: space-between;align-items: flex-start;height:60px;'><div style='display: -webkit-box;-webkit-line-clamp: 2;overflow: hidden;text-overflow: ellipsis;-webkit-box-orient: vertical;line-height: 1.2;'>${msgInfo.name}</div><div style="color:red">${msgInfo.ordinaryPrice.toFixed(2)}</div></div></div></div>`,
        };
      } else if (contentType == "order") {
        var msgInfo = JSON.parse(content);
        sessionStorage.setItem("goodsOrder", msgInfo.sonOrderNumber);
        let strStart = `<div style="width: 300px; height: auto; position: relative; color: #333; padding: 5px; cursor: pointer" onclick="toGoodsOrder()">`;
        let strEnd = `<div style="height: 1px; background: #ebebeb; width: 100%; margin: 10px 0 5px"></div><div style="font-size: 12px; color: #999">订单编号：${msgInfo.sonOrderNumber}</div></div>`;
        let str = "";
        msgInfo.commodityList.forEach((item) => {
          let img1 = `${this.CommonPath}${item.commoditySpecCoverImageUrls}`;
          let commodityName = item.commodityName;
          let ordinaryPrice = item.commodityMoney.toFixed(2);
          let commoditySpecName = item.commoditySpecName;
          let commodityNum = item.commodityNum;
          str += `<div class="flex-start" style='margin:10px 0'><img object-fit="fill" style="width: 80px; height: 80px; margin-right: 5px; object-fit: cover;border-radius: 10px;" src="${img1}" /><div style="width:100%;display: flex; flex-direction: column; justify-content: space-between; align-items: flex-start; height: 80px"><div style="display: -webkit-box;-webkit-line-clamp: 2;overflow: hidden;text-overflow: ellipsis;-webkit-box-orient: vertical;line-height: 1;">${commodityName}</div><div style='width:100%;display: flex;flex-direction: row;justify-content: space-between;align-items: center;color:#999'><div>${commoditySpecName}</div><div >x${commodityNum}</div></div><div style="color: red">${ordinaryPrice}</div></div></div>`;
        });
        text = {
          text: `${strStart}${str}${strEnd}`,
        };
      } else if (contentType == "doctorDesc") {
        var msgInfo = JSON.parse(content);
        let img1 = `https://oss.qyyl365.com/PC/touxiang.png`;
        if (msgInfo?.photoFile) {
          img1 = `${this.CommonPath}${msgInfo?.photoFile}`;
        }
        let img2 = `https://oss.qyyl365.com/PC/yirenzheng.png`;
        text = {
          text: `<div style='padding: 0px 10px;background: #f5f7fa;border-radius: 6px;width: 300px;margin: 20px auto;'><div class="flex-start userInfo" style='margin: 5px 0;'><img style='width: 45px;height: 45px;border-radius: 50%;margin-right:5px' src="${img1}" /><div><div class="flex-start"><div style='font-weight: bold;margin-right: 5px;text-align: left;'>${msgInfo.doctorName} ${msgInfo.departmentName}</div><img style="margin-right: 5px" src="${img2}" /></div><div style='color: #666666;font-size: 12px;text-align: left;'>证书编号：${msgInfo.certificateNumber}</div></div></div><div class="desc twoLine" style='line-height: 1.4;font-size: 12px;text-align: left;' v-if="${msgInfo.profile}">简介:${msgInfo.profile}</div></div>`,
        };
      } else if (contentType == "caseCard") {
        var msgInfo = JSON.parse(content);
        let sex = `${msgInfo.sex ? "男" : "女"}`;
        let age = `${this.getAge(msgInfo?.birthday)}岁`;
        let birthday = `(${msgInfo.birthday?.split("T")[0]})`;
        let relationshipToPatient = "";
        switch (msgInfo.relationshipToPatient) {
          case 0:
            relationshipToPatient = "本人";
            break;
          case 1:
            relationshipToPatient = "子女";
            break;
          case 2:
            relationshipToPatient = "父母";
            break;
          case 3:
            relationshipToPatient = "其他";
            break;
        }
        text = {
          text: `<div class="box" style='padding: 0px 10px;background: #f5f7fa;border-radius: 6px;width: 300px;margin: 20px auto;'><div class="flex-space-between top-title" style='margin-bottom: 5px;'><h4>病历卡</h4><div class="topRighgt-btn" style='color: #00afb5;font-size: 12px;'></div></div><div class="userInfo" style='margin: 5px 0;'><div class="doctor-1" style='font-weight: bold;margin-right: 5px;text-align: left;'>${msgInfo.patientName} ${msgInfo.departmentName}${sex} ${age}${birthday} ${relationshipToPatient}</div><div class="desc flex-start" style="text-align: left; margin: 5px 0; align-items: start;line-height: 1.4;font-size: 12px;text-align: left;"><div class="left-title" style='color: #999999;width: 60px;'>就诊疾病：</div><div class="right-val twoLine" style='width: calc(100% - 60px);'>${msgInfo.diseaseDiagnose}</div></div><div class="desc flex-start" style="text-align: left; align-items: start;line-height: 1.4;font-size: 12px;text-align: left;"><div class="left-title" style='color: #999999;width: 60px;'>病情描述：</div><div class="right-val twoLine" style='width: calc(100% - 60px);'>${msgInfo.description}</div></div></div></div>`,
        };
      }
      return text;
    },
    getAge(date) {
      const birthDate = new Date(date);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },
    toGoods() {
      if (this.$route.path != "/ShopMall/commodity") {
        this.$router.push("/ShopMall/commodity");
      } else {
        let str = sessionStorage.getItem("goodsName");
        this.copy(str, "goodsName");
        this.showDialog();
      }
    },
    toGoodsOrder() {
      if (this.$route.path != "/ShopMall/Order/OwnOrder") {
        this.$router.push("/ShopMall/Order/OwnOrder");
      } else {
        let str = sessionStorage.getItem("goodsOrder");
        this.copy(str);
        this.showDialog();
      }
    },
    copy(data, type) {
      let url = data;
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      console.log(oInput.value);
      document.execCommand("Copy"); // 执行浏览器复制命令
      if (type == "goodsName") {
        this.$message({
          message: "商品名称复制成功",
          type: "success",
        });
      } else {
        this.$message({
          message: "订单号复制成功",
          type: "success",
        });
      }

      oInput.remove();
    },
    toPage() {
      const routerData = this.$router.resolve({
        path: "/helpCenter",
      });
      window.open(routerData.href, "_blank");
    },

    /**
     * 显示聊天框
     */
    async showDialog() {
      this.getUserNotReadMessage();
      this.showJw = !this.showJw;
      if (this.showJw) {
        this.messageList = [];
        this.initUserGroup("isSetCurrentUserInfo");
      }
    },
    sendCard() {
      console.log("发送医生名片");
    },
    sendRecordCard() {
      console.log("发送病历卡");
    },
    /**
     * 终止问诊
     */
    stopConsultation() {
      this.refuseDialog = true;
      this.refuseForm = {
        id: this.currentUserInfo.groupName.split("_")[3],
        refusalReason: "",
      };
    },
    SaveBtn(formName) {
      var _this = this;
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          var item = this.refuseForm;
          _this.DoctorAppointment.AbortOrder(
            item.id,
            item.refusalReason,
            function (data) {
              _this.$message({
                type: "success",
                message: "操作成功!",
              });
              _this.$refs[formName].resetFields();
              _this.refuseDialog = false;
            },
            function (err) {
              var jsonObj = JSON.parse(err.msg);
              if (jsonObj.code == "400") {
                _this.$message({
                  type: "error",
                  message: jsonObj.msg,
                });
              }
            }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    CloseBtn(formName) {
      this.$refs[formName].resetFields();
      this.refuseDialog = false;
    },
    /**
     * 完成问诊
     */
    complateConsultation() {
      var _this = this;
      _this.DoctorAppointment.DoctorCompleteOrder(
        _this.currentUserInfo.groupName.split("_")[3],
        function (data) {
          _this.sendEnter(_this.currentUserInfo.id, "isEnd", "问诊已结束等待患者确认结束", _this.orgInfo.id, true);
        },
        function (err) {
          var jsonObj = JSON.parse(err.msg);
          if (jsonObj.code == "400") {
            _this.$message({
              type: "error",
              message: jsonObj.msg,
            });
          }
        }
      );
    },
    /**
     * 点击发送或回车
     */
    async bindEnter() {
      const msg = this.inputMsg;
      if (!msg) return;
      this.sendEnter(this.currentUserInfo.id, "message", msg, this.orgInfo.id, true);
    },
    /**
     *
     * @param groupID
     * @param contentType  mssage:文字消息/image:图片消息/link:链接/video:视频/order:订单消息
     * @param content
     * @param fromUserId
     * @param isServer 是否客服
     */
    async sendEnter(groupID, contentType, content, fromUserId, isServer) {
      let map = [Number.parseInt(groupID), contentType, content, Number.parseInt(fromUserId), isServer];
      const message = {
        protocol: "json",
        version: 1,
        arguments: map,
        target: "SendMessageToUser",
        type: 1, // 表示调用方法
      };
      try {
        console.log("发送消息", contentType, content);

        this.$chathubService.sendWebsocket(JSON.stringify(message) + "\u001E");
      } catch (ex) {
        console.log("消息发送失败，重新发送。", ex.toString());
        this.$chathubService.sendWebsocket(JSON.stringify(message) + "\u001E");
      }
    },
    /**
     * 日期格式化
     * @param val
     */
    timefilters(val) {
      if (val == null || val == "") {
        return "-";
      } else {
        let d = new Date(val); //val 为表格内取到的后台时间
        let month = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
        let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
        let hours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
        let min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
        let sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
        let times = d.getFullYear() + "-" + month + "-" + day + " " + hours + ":" + min + ":" + sec;
        return times;
      }
    },
    /**
     * 日期转时间戳
     * @param val
     */
    timeFormat(val) {
      const date = new Date(val); // 获取当前日期对象
      return date.getTime();
    },
    // 点击聊天框列中的用户和昵称触发事件
    talkEvent(play) {
      console.log(play);
    },
    /**
     * @description:点击工具框
     * @param {*} type 当前点击的按钮
     * @param {*} plyload 附加文件或者需要处理的数据
     * @return {*}
     */
    toolEvent(type, plyload) {
      switch (type) {
        case "file":
          if (plyload.length > 0) {
            for (let index = 0; index < plyload.length; index++) {
              let element = plyload[index];
              let strList = element.name.split(".");
              let lastStr = strList[strList.length - 1];
              let imgType = ["jpg", "jpeg", "png", "gif"];
              let videoType = ["mp4", "MP4"];
              if (imgType.indexOf(lastStr) == -1 && videoType.indexOf(lastStr) == -1) {
                this.$message({
                  type: "error",
                  message: "请选择图片、视频",
                });
                return;
              } else {
                if (imgType.indexOf(lastStr) > -1) {
                  this.uploadImg(element);
                }

                if (videoType.indexOf(lastStr) > -1) {
                  this.uploadVideo(element);
                }
              }
            }
          }
          break;
        case "img":
          break;
        case "video":
          break;
      }
    },
    showGoods() {
      let _this = this;
      let shopId = sessionStorage.getItem("shopId");
      _this.CommodityDomain.CommoditySeachPages(
        0,
        0,
        0,
        shopId,
        "",
        _this.PageIndex3,
        function (data) {
          _this.dialogVisible = true;
          _this.goodsList = data.data.results;
          _this.PageIndex3 = data.data.pageIndex;
          _this.PageSize3 = data.data.pageSize;
          _this.PageTotal3 = data.data.pageCount;
          _this.dataCount3 = data.data.dataTotal;
        },
        function (err) {
          console.log(err);
        }
      );
    },
    ChangePage(pageIndex) {
      this.PageIndex3 = pageIndex;
      this.showGoods();
    },
    sedGoods(item) {
      let str = JSON.stringify(item);
      this.sendEnter(this.currentUserInfo.id, "goods", str, this.orgInfo.id, true);
      this.dialogVisible = false;
    },
    /**
     * 上传视频
     * @param element
     */
    beforeUploadVideo(file) {
      //上传文件的大小
      const isLt20M = file.size / 1024 / 1024 < 200;
      //'video/ogg', 'video/flv', 'video/avi', 'video/wmv', 'video/rmvb','video/mp4' 可支持上传的视频类型
      if (["video/mp4"].indexOf(file.type) == -1) {
        this.$message.error("请上传正确的视频格式");
        return false;
      }
      if (!isLt20M) {
        this.$message.error("上传视频大小不能超过200MB哦!");
        return false;
      }
      loading = this.$loading({
        lock: true,
        // text: '正在上传视频...',
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.4)",
      });
      let fileStr = file;
      this.$refs.uploadVideo.clearFiles();
      this.uploader = this.createUploader();
      var userData = '{"Vod":{}}';
      this.uploader.addFile(fileStr, null, null, null, userData);
      this.uploader.startUpload();
    },
    beforeUpload() {
      loading = this.$loading({
        lock: true,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.4)",
      });
    },
    /**
     * 上传图片
     * @param element
     */

    handleSuccess(response, file, fileList) {
      loading.close();
      var _this = this;
      let res = response;
      this.$refs.upload.clearFiles();
      res.forEach(function (file) {
        var imgPath = file.completeFilePath;
        _this.sendEnter(_this.currentUserInfo.id, "image", imgPath, _this.orgInfo.id, true);
      });
    },
    createUploader() {
      let _this = this;
      var uploader = new AliyunUpload.Vod({
        userId: "1922508017966810",
        //上传到点播的地域，默认值为'cn-shanghai'，//eu-central-1，ap-southeast-1，更多信息请参见存储说明
        region: "cn-shanghai",
        //开始上传
        addFileSuccess: function (uploadInfo) {
          console.log(uploadInfo);
        },
        onUploadstarted: function (uploadInfo) {
          let params = {
            title: "视频名称",
            fileName: uploadInfo.file.name,
          };
          _this.VideosDomain.GetVideoCertificate(
            params,
            function (data) {
              uploader.setUploadAuthAndAddress(uploadInfo, data.data.uploadAuth, data.data.uploadAddress, data.data.videoId);
              _this.videoId = data.data.videoId;
            },
            function (error) {
              _this.$message.error("视频上传失败！");
              loading.close();
            }
          );
          // }
        },
        //文件上传成功
        onUploadSucceed: function (uploadInfo) {
          _this.resVideo = "http://video.qyyl365.com/" + uploadInfo.object;
          let videoPath = "http://video.qyyl365.com/" + uploadInfo.object;
          loading.close();
          if (videoPath) {
            _this.sendEnter(_this.currentUserInfo.id, "video", videoPath, _this.orgInfo.id, true);
          }
        },
        //文件上传失败
        onUploadFailed: function (uploadInfo, code, message) {
          loading.close();
          uploader.stopUpload();
        },
        //文件上传进度，单位：字节
        onUploadProgress: function (uploadInfo, totalSize, loadedPercent) {
          // _this.percentage = parseInt((loadedPercent * 100).toFixed(2))
        },
        //上传凭证过期
        onUploadTokenExpired: function (uploadInfo) {
          console.log("1111111");
          // loading.close();
        },
        //全部文件上传结束
        onUploadEnd: function (uploadInfo) {
          _this.uploaded = true;
        },
      });
      return uploader;
    },
    /**
     * @description: 点击加载更多的回调函数
     * @param {*}
     * @return {*}
     */
    bindLoadHistory() {
      this.pageIndex++;
      this.config.historyConfig.tip = "加载中";
      this.getMessagesBygroupId("loadMore");
    },
    bindCover(type) {
      console.log("header", type);
    },

    /**
     * 获取当前聊天组信息
     * @param {*} sessionId
     */
    getMessagesBygroupId(loadMore) {
      var _this = this;
      _this.UserChat.GetGroupHistoryChatMessage(
        this.currentUserInfo.id,
        this.currentUserInfo.bindUserId,
        this.pageIndex,
        10,
        function (data) {
          let messageList = [];
          let array = data.data.results;
          array.forEach((item) => {
            if (!_this.messageList.some((i) => i.id == item.id)) {
              var text = _this.getMsgStr(item.contentType, item.content);
              var message = {
                id: item.id, //消息编号
                // SessionId: item.SessionId, //会话编号
                groupId: item.groupId,
                FromUserId: item.fromUserId, //发送者
                To: item.toUser, //接收者，MsgType=USER时为用户ID，MsgType=GROUP时为群ID
                MsgType: item.msgType, //消息类型，同item.SessionType
                mine: item.fromUserId == _this.currentUserInfo.bindUserId ? false : true,
                img: item.fromUserId == _this.currentUserInfo.bindUserId ? _this.currentUserInfo.img : _this.shopLogo,
                name: item.fromUserId == _this.currentUserInfo.bindUserId ? "" : item.name,
                date: _this.timefilters(item.sendTime), //发送时间
                text: text, //正文
                Timestamp: _this.timeFormat(item.sendTime),
                ContentType: item.contentType, //正文类型
              };
              messageList.push(message);
            }
          });
          if (messageList.length > 0) {
            if (_this.messageList.length == 0) {
              _this.messageList = messageList.concat(_this.messageList);
            } else {
              if (_this.messageList[0].Timestamp < messageList[0].Timestamp) {
                _this.messageList = _this.messageList.concat(messageList);
              } else {
                _this.messageList = messageList.concat(_this.messageList);
              }
            }
            if (loadMore) {
              _this.$nextTick(() => {
                _this.$refs.jwChat.finishPullDown();
              });
            }
          }
        },
        function (err) {
          console.log(err);
          var jsonObj = JSON.parse(err.msg);
          if (jsonObj.code == "400") {
            _this.$message({
              type: "error",
              message: jsonObj.msg,
            });
          }
        }
      );
    },
    loginout() {
      this.$confirm("此操作将注销登录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loadMsg = false;
          this.isLogin = false;
          if (this.exchange) {
            this.exchange.Logout();
          }
          window.sessionStorage.clear();
          this.$socket.close();
          //if (this.ClientId == this.QYClient) 
          this.$chathubService.close();
          this.$message.success("已退出");
          this.exchange = "";
          this.$router.push("/login");
          //触发后禁止浏览器的后退键
          history.pushState(null, null, document.URL);
          window.addEventListener(
            "popstate",
            function (e) {
              history.pushState(null, null, document.URL);
            },
            false
          );
          // this.getRequest("/logout");
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    initMsg() {
      window.addEventListener("onmessageWS", this.getSocketData);
      // 检测浏览器是否支持Websocket
      if (typeof WebSocket == "undefined") {
        this.$alert("系统检测到您的浏览器不支持Websocket通信协议，这将会导致您无法正常进行课堂互动！建议您更换浏览器进行观看！", "警告", {
          confirmButtonText: "知道了",
          callback: () => {},
        });
      }
    },
    getSocketData(res) {
      let data = res.detail.data;
      if (data.Code == 200 && data.Data) {
        this.showMsgDot = true;
        this.setPagePath(data.Data);
      }
    },
    setPagePath(res) {
      let msg = `${res.Content}`;
      let query = {};
      let path = "";
      let tip = "";
      //  消息类型 type ： 0 系统消息    2 快递消息  3 支付消息 （支出和入账）4 账号消息5 申请消息6 门诊消息 7 转诊消息  8 升级续费消息 9 平台消息 10 聊天消息
      //  子类型 SubType：
      //  机构后台门诊消息  1付款成功开始备药  2退款申请通知      3库存预警消息     4效期预警消息 29下架商品 30禁用商家
      //  总后台 5机构提现申请消息  6机构升级版本申请  7机构申请入驻   8店铺开通申请 9商品审核申请  10平台介入申请 11 议价申请消息
      //  医生端/app/小程序 门诊消息   12审方医生消息    13  审核成功通知  14 审核拒绝通知  15退款拒绝通知
      //  医生端/app/小程序 账号/会员消息  16会员即将到期  17会员已到期
      //  代理商后台升级续费消息  18续费升级申请  19对公审批完成  20 议价审批通知
      //  代理商后台账号消息  21机构审核申请 22店铺开通申请
      // 31商品发货 32商品退款申请
      //  聊天消息: 100健康档案聊天 101门诊聊天 102 商城聊天
      switch (res.SubType) {
        case 1:
          path = "/Outpatient/ChargedList";
          // query = { orderNum: `${JSON.parse(res.JumpOp).OrderNum}` }
          tip = "开始备药";
          break;
        case 2:
          path = "/Outpatient/RefundReviewList";
          // query = { orderNum: `${JSON.parse(res.JumpOp).OrderNum}` }
          tip = "去审核";
          break;
        case 3:
          path = "/Outpatient/InventoryAlert";
          tip = "去查看";
          break;
        case 4:
          path = "/Outpatient/ExpireAlert";
          tip = "去查看";
          break;
        case 29:
          path = "/ShopMall/seedBackCommodity";
          tip = "去查看";
          break;
        case 31:
          path = "/ShopMall/Order/OwnOrder";
          tip = "去查看";
          break;
        case 32:
          path = "/ShopMall/Order/OwnRefund";
          tip = "去查看";
          break;
      }
      this.setMessage(res.Title, path, query, msg, tip);
    },
    setMessage(title, path, query, msg, tip, messageType) {
      if (messageType == "chat") {
        this.setChatMessage(title, path, query, tip);
        return;
      }
      let _this = this;
      const h = this.$createElement;
      let notify = this.$notify({
        title: title,
        message: h(
          "span",
          {
            style: {
              "word-break": "break-all",
              "overflow-wrap": "break-word",
            },
          },
          [
            msg,
            h(
              "el-link",
              {
                attrs: {
                  type: "primary",
                },
                on: {
                  click: (event) => {
                    // 阻止默认行为
                    event.preventDefault();
                    if (path && _this.$route.path !== path) {
                      _this.$router.push({
                        path: path,
                        query: query,
                      });
                    }
                    if (tip == "去解决" && !_this.showJw) {
                      _this.showDialog();
                    }
                    notify.close();
                    _this.showMsgDot = false;
                  },
                },
              },
              tip
            ),
          ]
        ),
        position: "bottom-right",
        duration: 0,
        offset: 20,
        type: "warning",
        dangerouslyUseHTMLString: true,
      });
    },
    setChatMessage(title, path, query, tip) {
      let _this = this;
      const h = this.$createElement;
      this.chatMessageCount++;
      const message = h(
        "span",
        {
          style: {
            "word-break": "break-all",
            "overflow-wrap": "break-word",
          },
        },
        [
          `您有${this.chatMessageCount}条聊天消息需要处理`,
          h(
            "el-link",
            {
              attrs: {
                type: "primary",
              },
              on: {
                click: (event) => {
                  event.preventDefault();
                  if (path && _this.$route.path !== path) {
                    _this.$router.push({
                      path: path,
                      query: query,
                    });
                  }
                  if (!_this.showJw) {
                    _this.showDialog();
                  }
                  if (_this.chatMessageNotify) {
                    _this.chatMessageNotify.close();
                  }
                  _this.showMsgDot = false;
                },
              },
            },
            tip
          ),
        ]
      );

      if (this.chatMessageNotify) {
        this.chatMessageNotify.$slots.default = [message]; //替换当前弹框的显示内容
        this.chatMessageNotify.$forceUpdate(); //通知 Vue 立即刷新弹框
        return;
      }

      this.chatMessageNotify = this.$notify({
        title: title,
        message: message,
        position: "bottom-right",
        duration: 0,
        offset: 20,
        type: "warning",
        dangerouslyUseHTMLString: true,
        onClose() {
          _this.chatMessageNotify = null;
          _this.chatMessageCount = 0;
        },
      });
    },
    showMsg() {
      this.$router
        .push({
          path: "/System/MsgList",
          query: {},
        })
        .catch(() => {});
    },
    toSquare() {
      this.$router.push("/square");
    },
  },
};
</script>

<style>
.header {
  flex: 1;
  text-align: right;
  margin-right: 15px;
}

.messages {
  margin-top: 13px;
  margin-right: 20px;
}

.messages .el-icon-bell {
  font-size: 24px;
}
</style>
<style scoped>
.jw-box {
  position: absolute;
  width: 100vw;
  width: 100%;
  top: 73px;
  left: 0;
  right: 0;
  height: calc(100vh - 95px);
  background: #f5f6fa;
}

.closeBtn {
  position: absolute;
  right: calc(5% + 10px);
  top: 30px;
  z-index: 999999999;
  color: #000;
  font-size: 20px;
  cursor: pointer;
}

.jw /deep/ .windowBar {
  border: 1px solid #eaeaea;
  /* box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%); */
  padding: 10px;
  border-radius: 12px 0 0 12px;
}
.jw /deep/ .wrapper .web__main {
  width: 94%;
  padding: 0;
  left: 3%;
}

.jw /deep/ .wrapper {
  width: 100%;
  height: 100%;
}
/**左侧 */
.jw /deep/ .windowBar .winItem {
  border: none;
  height: auto !important;
  margin: 5px 0;
  padding: 10px 10px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start !important;
  align-items: center;
}

.jw /deep/ .windowBar .winItem .itemOperation {
  display: none;
}
.jw /deep/ .windowBar .winItem:hover {
  background: #f5f7fa;
  border-radius: 4px;
}

.jw /deep/ .windowBar .winActive {
  background: #f5f7fa !important;
  border-radius: 4px;
}
.jw /deep/ .windowBar .info .name {
  color: #333;
  font-size: 14px;
  width: calc(14vw - 80px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: bold;
  /* line-height: 1; */
}
.jw /deep/ .windowBar .info .dept {
  color: #999;
  font-size: 12px;
  line-height: 1;
  width: calc(14vw - 80px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.jw /deep/ .windowBar .winBarBox {
  width: 100%;
  padding: 0;
  margin-bottom: 20px;
}

.jw /deep/ .winBarBox .item .el-badge {
  width: 40px;
  height: 40px;
  margin-right: 5px;
}

.jw /deep/ .winBarBox .item .el-badge img {
  border-radius: 4px;
}

.jw /deep/ .winBarBox .bscroll-vertical-scrollbar {
  display: none !important;
}
.jw /deep/ .chatBox .bscroll-vertical-scrollbar {
  display: none !important;
}
.jw /deep/ .winBarBox .item .cover {
  position: absolute;
  top: 4px;
  left: 0;
  border-radius: 0;
}
.jw-box /deep/ .ChatPage .winBar {
  border-right: 5px solid #f0f2f5;
  /* border-radius: 12px 0 0 12px; */
}
.jw-box /deep/ .ChatPage .ChatPage-main .main {
  width: calc(100%) !important;
}
/* 中间 */
.jw-box /deep/ .ChatPage .header {
  /* background-color: var(--base--Color); */
  background: #ffffff !important;
  border-radius: 4px;
  border-bottom: 5px solid #f0f2f5;
  border-radius: 0px 12px 0 0;
}

.jw-box /deep/ .wrapper .web__main .web__main-arrow:after {
  border-right-color: #f5f7fa;
}

.jw-box /deep/ .wrapper .web__main .web__main-item--mine .web__main-text .web__main-arrow:after {
  border-left-color: #f5f7fa;
}
.jw-box /deep/ .ChatPage .ChatPage-main .info p {
  /* background-color: var(--base--Color); */
  font-size: 16px !important;
  color: #333333 !important;
}
.jw-box /deep/ .ChatPage {
  margin-left: 5%;
  border-radius: 12px;
}
.jw-box /deep/ .ChatPage .ChatPage-main .main .rightBox .switch {
  display: none;
}

.jw-box /deep/ .wrapper .web__main .web__main-text {
  background: #f5f7fa;
  /* box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%); */
}
.jw-box /deep/ .ChatPage .ChatPage-main .main .rightBox {
  width: 16vw;
  border-left: 5px solid #f0f2f5;
  box-shadow: none;
  padding: 5px 0;
}

.jw-box /deep/ .wrapper .userList {
  display: none;
}
.jw-box /deep/ .wrapper .notice {
  height: 100%;
}
.jw-box /deep/ .ChatPage .rightBox .info p {
  color: #666;
}
.jw-box /deep/ .ChatPage .rightBox .item .cover {
  border-radius: 0;
}
.jw /deep/ .wrapper .web__main .web__main-item--mine .web__main-text {
  border-radius: 10px;
  background: #f5f7fa;
  border: none;
}

.jw /deep/ .wrapper .web__main .web__main-item--mine .web__main-text {
  color: #333;
  /* box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%); */
}

.jw /deep/ .el-button--primary {
  background-color: var(--base--Color);
  border-color: var(--base--Color);
}

.jw /deep/ .wrapper .web__main .web__main-item--mine .web__main-text .web__main-arrow {
  border-left-color: #f5f7fa;
}

.jw /deep/ .wrapper .downBtn:before {
  content: "▼";
  color: #cacaca;
  background: #eee;
  font-size: 12px;
  padding-top: 2px;
  width: 28px;
  height: 28px;
}

.jw /deep/ .wrapper .downBtn:hover:before {
  color: #fff;
  background: var(--base--Color);
}

.jw /deep/ .bscroll-indicator {
  background: #eee !important;
}
.jw /deep/ .wrapper .web__main .web__main-user img {
  width: 35px;
  height: 35px;
  border-radius: 5px !important;
}
.jw /deep/ .wrapper .web__main .web__main-item {
  margin-top: 10px;
}
.jw /deep/ .wrapper .web__main .web__main-user cite {
  top: -5px;
  left: 40px;
}
.jw /deep/ .wrapper .web__main .web__main-item--mine .web__main-user cite i {
  padding-right: 0;
}
.jw /deep/ .wrapper .web__main .web__main-text {
  padding: 5px 15px;
  margin-top: 20px;
  border-radius: 10px;
  color: #333;
}
.header :deep() .el-badge__content.is-dot {
  width: 12px;
  height: 12px;
}
.jw-box /deep/ .chatPage .toolBox {
  padding: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.05);
}
</style>
<style scoped>
#session-container {
  margin: 0px;
  padding: 0px;
  width: 200px;
  height: 480px;
  overflow-y: scroll;
  overflow-x: hidden;
}

#session-container .session-item {
  width: 180px;
  height: 50px;
  line-height: 20px;
  margin-top: 5px;
  margin-bottom: 5px;
}

#session-container .session-item:hover {
  background: #efefef;
}

#session-container .session-item .session-item-photo {
  width: 50px;
  height: 50px;
  margin-left: 10px;
  margin-right: 10px;
  float: left;
}

#session-container .session-item .session-item-photo img {
  width: 50px;
  height: 50px;
  margin: 0px;
  padding: 0px;
}

#session-container .session-item .session-item-info {
  width: 110px;
  height: 50px;
  float: left;
}

#session-container .session-item .session-item-info .session-item-username {
  width: 110px;
  height: 25px;
  line-height: 25px;
}

#session-container .session-item .session-item-info .session-item-lastmessage {
  width: 110px;
  height: 25px;
  line-height: 25px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

#session-message-container {
  width: 1000px;
  height: 390px;
  margin: 0px;
  margin-bottom: 10px;
  padding: 0px;
  overflow-y: scroll;
  overflow-x: hidden;
}

#session-message-container .session-message-item {
  margin: 10px;
}
</style>
